// src/utils/ApiPath.js

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3006/api'
    : 'https://api.luckymawin.fun/api';

export const API_PATHS = {
  STAFF_LOGIN: `${BASE_URL}/auth/login`,
  GET_REWARD: `${BASE_URL}/rewards`,
  CREATE_REWARD: `${BASE_URL}/rewards`,
  EDIT_REWARD: (id) => `${BASE_URL}/rewards/${id}`,
  DELETE_REWARD: (id) => `${BASE_URL}/rewards/${id}`,
  CREATE_USER_GEN_CODE: `${BASE_URL}/user-code/generate/create`,
  GET_USER_GEN_CODE: `${BASE_URL}/user-code/generate/getall`,
  USE_CODE: `${BASE_URL}/user-code/redeem`,
  CHECK_CODE: `${BASE_URL}/user-code/redeem/check`,
  GET_SPIN_REWARDS: `${BASE_URL}/spin/rewards`,
};
